module.exports = __webpack_public_path__ + "static/media/exclusief-logo.fb3d3a3e.png";